<div *ngIf="order$ | async as order" class="cx-order-summary container">
  <div class="row justify-content-end">
    <div class="col-sm-12 col-md-6">
      <jaga-order-summary [cart]="order"> </jaga-order-summary>
    </div>
  </div>
</div>
